import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

export default function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string
  subtitle?: string
  actions?: React.ReactNode
}) {
  return (
    <Stack direction="row" alignItems="flex-start" spacing={2} sx={{ mb: 2 }}>
      <Box
        sx={{
          mt: '2px',
          width: 4,
          height: 32,
          borderRadius: 1,
          bgcolor: 'primary.main',
          flexShrink: 0,
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: -0.3 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Box sx={{ ml: 'auto', pt: '2px' }}>
          {actions}
        </Box>
      ) : null}
    </Stack>
  )
}

